// extracted by mini-css-extract-plugin
export default {"transactionTrend":"TransactionCard_transactionTrend__KW2zl","infoImg":"TransactionCard_infoImg__KSsSr"};